import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BudgetImportBO, ClientContactInfoBO } from './budgetplan-form.model';
import { caseManagerList } from '../case-manager/case-manager.model';
import { ErrorService } from 'src/app/error.service';

@Injectable({
  providedIn: 'root'
})
export class budgetService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  savebudget(saveContact: BudgetImportBO): Observable<any> {
    let url = "api/Budget/SaveBudget";
    return this.http.post<any>(url, saveContact, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetAllClientsDropDownbyAgency(params: URLSearchParams): Observable<any> {
    let url = "api/Client/GetAllClientsDropDownbyAgency?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  gettype(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Lov/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getgrouppayorservice(paramsData: URLSearchParams): Observable<[{ Key: number, Value: string }]> {
    let url = "api/ClientAuthorization/GetServicedropdown?";
    return this.http.get<[{ Key: number, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  getPayorDropDown(savelist: any): Observable<[{ Key: number, Value: string }]> {
    let url = "api/Client_Budget/GetGroupPayorList?";
    return this.http.post<any>(url, savelist, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  getServiceDescription(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClientAuthorization/GetServiceDescription?";
    const requestOptions: Object = {
      /* other options here */
      responseType: 'text'
    }
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getbillingvalue(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClientAuthorization/GetBilling?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getbudget(params: URLSearchParams): Observable<any> {
    let url = "api/BudgetImport/GetBudgetImportList?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getbudgetBO(params: URLSearchParams): Observable<any> {
    let url = "api/Budget/GetBudgetById?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getbudgetBOOnboard(params: URLSearchParams): Observable<any> {
    let url = "api/Client_Budget/GetBudgetById?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getcommon(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Lov/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetAllClientsDropDownby(params: URLSearchParams): Observable<any> {
    let url = "api/BudgetImportClient/GetAllClientsDropDownbyAgencyOnboard?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  GetAllClientDetails(params: URLSearchParams): Observable<any> {
    let url = "api/Budget/GetClientDetails?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  GetAllClientDetailsOnboard(params: URLSearchParams): Observable<any> {
    let url = "api/Client_Budget/GetClientDetails?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  GetAllClient(): Observable<any> {
    let url = "api/EmployeePayrate/GetcliDD"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }
  GetAgencyDetails(): Observable<any> {
    let url = "api/Budget/GetAgencyDetails"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  GetAgencyDetailsForOnboard(): Observable<any> {
    let url = "api/Client_Budget/GetAgencyDetails"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  GetCaseManager(): Observable<any> {
    let url = "api/Budget/GetCasemanagerDropdown"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  GetCaseManagerOnboard(): Observable<any> {
    let url = "api/Client_Budget/GetCasemanagerDropdown"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  GetSupportPlanner(): Observable<any> {
    let url = "api/Budget/GetSupportplannerDropdown"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  GetSupportPlannerOnboard(): Observable<any> {
    let url = "api/Client_Budget/GetSupportplannerDropdown"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  getgrouppayor(paramsData: URLSearchParams): Observable<[{ Key: number, Value: string }]> {
    let url = "api/BudgetImportClient/GetServicedropdownForOnboard?";
    return this.http.get<[{ Key: number, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getPayorDrop(): Observable<[{ Key: number, Value: string }]> {
    let url = "api/Payer/GetGroupPayorList?";
    return this.http.get<[{ Key: number, Value: string }]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getbilling(paramsData: URLSearchParams): Observable<any> {
    let url = "api/BudgetImportClient/GetBilling?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getbudge(params: URLSearchParams): Observable<any> {
    let url = "api/BudgetImportClient/GetBudgetBo?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getClientContact(params: URLSearchParams): Observable<any> {
    let url = "api/Budget/GetClientContact?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getClientContactOnboard(params: URLSearchParams): Observable<any> {
    let url = "api/Client_Budget/GetClientContact?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getClientInfo(paramsData: URLSearchParams): Observable<any> {
    let url = "api/BudgetImport/GetClientInfo?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getClientOnboard(paramsData: URLSearchParams): Observable<any> {
    let url = "api/BudgetImport/GetClientInfoOnboard?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  /////case manager////
  saveupdate(saveList: caseManagerList): Observable<any> {
    let url = "api/CaseManager/SaveCaseManager";
    return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //////contact////////
  SaveOrUpdateContactInfo(saveEmployeeContact: ClientContactInfoBO): Observable<any> {
    let url = "api/ClientContactInfo/SaveCliContactInfo";
    return this.http.post(url, saveEmployeeContact, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getZipcode(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Client/getZipcode?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getServiceDropdownForAdmin(params: URLSearchParams): Observable<any> {
    let url = "api/Service/GetServiceDropdownBasedOnGroup?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getServiceDropdownForotherUser(params: URLSearchParams): Observable<any> {
    let url = "api/Client_Budget/GetServiceDropdownBasedOnGroup?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  deleteEvaluationLastYearPlan(params3: URLSearchParams) {
    let url = "api/Budget/DeleteBudgetEvaluationofLastYearPlan?";
    return this.http.delete<any>(url + params3).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  deleteAdditionalContacts(params2: URLSearchParams) {
    let url = "api/Budget/DeleteAdditionalContacts?";
    return this.http.delete<any>(url + params2).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  deleteRepresentativeContacts(params1: URLSearchParams) {
    let url = "api/Budget/DeleteRepresentativeContacts?";
    return this.http.delete<any>(url + params1).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  deleteBudegtExpenditure(params1: URLSearchParams) {
    let url = "api/Budget/DeleteBudgetExpendituresMonitors?";
    return this.http.delete<any>(url + params1).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  deleteBudegtHealthSafetyMonitors(params1: URLSearchParams) {
    let url = "api/Budget/DeleteBudgetHealthandSafetyMonitors?";
    return this.http.delete<any>(url + params1).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  deleteBudegtGoals(params1: URLSearchParams) {
    let url = "api/Budget/DeleteBudgetGoals?";
    return this.http.delete<any>(url + params1).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  deleteBudgetAuthorization(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Budget/GetBudgetAuthDelete?";
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getCompanyDropDown(): Observable<any> {
    let url = "api/Budget/getCompany?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getCompanyDropDownForOnboard(): Observable<any> {
    let url = "api/Client_Budget/getCompany?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getbudgetLog(params: URLSearchParams): Observable<any> {
    let url = "api/BudgetLog/GetBugetLog?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}